const addUrlParameterToUrl = (url, paramName, paramValue) => {
  const urlObj = new URL(url);
  urlObj.searchParams.set(paramName, paramValue);
  return urlObj.toString();
};

export default addUrlParameterToUrl;
